import React from "react";
import { HTMLAttributes } from "react";
import { classNames } from "@greeter/util";

import css from "./RoundedButton.module.scss";

export type RoundedButtonProps = React.ComponentProps<"button"> & {
  active?: boolean;
  activeClassName?: string;
};

export function RoundedButton({
  activeClassName,
  active,
  className,
  ...props
}: RoundedButtonProps) {
  return (
    <button
      {...props}
      {...classNames(
        className,
        css.RoundedButton,
        props.disabled && css.Disabled,
        active && [css.Active, activeClassName]
      )}
    />
  );
}
